// FILE: src/theme/theme.js
const THEME_KEY = "ds-theme";

export function getSystemTheme() {
  try {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  } catch {
    return "light";
  }
}

export function readSavedTheme() {
  try {
    return localStorage.getItem(THEME_KEY);
  } catch {
    return null;
  }
}

export function saveTheme(theme) {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {}
}

export function applyTheme(theme) {
  const t = theme || "light";
  document.documentElement.setAttribute("data-bs-theme", t);
  document.documentElement.setAttribute("data-theme", t);
}
